export enum SECTIONS {
  PREVIEW = 'preview',
  MODULES = 'home',
  WORKSPACE = 'workspace',
  COURSES = 'workflows',
  COURSE = 'workflow',
  GROUPS = 'groups',
  SYSTEMS = 'integrations',
  ADMINISTRATORS = 'admins',
  CERTIFICATES = 'certificates',
  VARIABLES = 'records',
  THEME = 'theme'
}
